import { render, staticRenderFns } from "./toggleSwitch.vue?vue&type=template&id=12496026&"
import script from "./toggleSwitch.vue?vue&type=script&lang=js&"
export * from "./toggleSwitch.vue?vue&type=script&lang=js&"
import style0 from "./toggleSwitch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports